import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { useParams, useNavigate as useHistory } from 'react-router-dom'

import { dialogSize, getRoute, routePaths } from '../../../../constants'
import { importScenario } from '../../../../actions'
import { checkErrorResponse, Logger, LoggerTypes } from '../../../../utils'
import { DialogFormImport } from '../../../../components/dialogs/DialogFormImport'
import { ScenarioImportForm } from '../ScenarioImportForm'
import './style.scss'

export const ScenarioDialogImport = ({ openDialog, setOpenDialog }) => {
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const params = useParams()
  const navigateTo = useHistory()
  const { t } = useTranslation()

  // -- get projectID from URL.
  const { pid } = params

  const onDispatchAction = (importPid, importSid, targetProject, _onSuccess, _onFail) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'ScenarioDialogImport.onDispatchAction()', {
      pid,
      importPid,
      importSid,
      targetProject
    })

    dispatch(importScenario(importPid, importSid, targetProject))
      .then((res) => {
        Logger.trace(LoggerTypes.CONTROLLER, 'ScenarioDialogImport.dispatch(importScenario()).then()', {
          res
        })

        const newScenario = res?.data || {}
        if (newScenario.id) {
          setOpenDialog(!openDialog)
          navigateTo(getRoute(routePaths.SCENARIO_FLOW_GROUPS, { pid, sid: newScenario.id }))
        } else {
          enqueueSnackbar(t('common.api_failure'), newScenario)

          if (_onFail && typeof _onFail === 'function' && res?.response?.data?.fields) {
            _onFail(res?.response?.data?.fields)
          }
        }
      })
      .catch((res) => {
        Logger.trace(LoggerTypes.WARN, 'ScenarioDialogImport.dispatch(importScenario()).catch()', {
          res
        })

        checkErrorResponse(res, enqueueSnackbar, t)

        if (_onFail && typeof _onFail === 'function' && res?.response?.data?.fields) {
          _onFail(res.response.data.fields)
        }
      })
  }

  Logger.trace(LoggerTypes.CONTAINER, 'ScenarioDialogImport.render()')

  return (
    <DialogFormImport
      className="ScenarioDialogImport"
      openDialog={openDialog}
      setOpenDialog={setOpenDialog}
      maxWidth={dialogSize.EXTRA_SMALL}
    >
      <ScenarioImportForm
        title={t('scenarios.dialogs.import.title')}
        setOpenDialogVariable={setOpenDialog}
        dispatchAction={onDispatchAction}
      />
    </DialogFormImport>
  )
}

ScenarioDialogImport.displayName = 'ScenarioDialogImport'

ScenarioDialogImport.propTypes = {
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  title: PropTypes.string
}

ScenarioDialogImport.defaultProps = {
  openDialog: false,
  setOpenDialog: () => {},
  title: null
}
